<template>
  <el-dialog
    :visible="is_visible"
    ref="dialog"
    :title="getStageName"
    :width="getCurrentStep && getCurrentStep.single_popup ? '790px' : '1100px'"
    :close-on-click-modal="false"
    @close="closeDialog"
    class="dialog general_dialog"
  >
    <div class="dialog__content" v-loading="getLoading">
      <div
        class="dialog__content__left"
        :class="getCurrentStep && getCurrentStep.single_popup ? 'hide' : 'open'"
      >
        <div v-for="item in getSteps" :key="item.id">
          <GeneralMenuItem
            :key="getStepKey"
            :item="item"
            @changeStep="changeStep"
            @changeRequired="changeRequired"
          />
        </div>
      </div>
      <div class="dialog__content__right" v-loading="formLoading">
        <div v-for="(item, index) in getSteps" :key="`${index}_${item.id}`">
          <div v-show="currentStep === item.id">
            <!-- {{ item.actions }} -->
            <div ref="form-HRPAC_EVENT" v-if="item.id === 'HRPAC_EVENT'">
              <div v-if="!item.warning">
                <slot></slot>
              </div>
              <div v-else>
                <MetadataForm
                  :ref="`form-${item.id}`"
                  :defParams="item.defaultParams.open"
                  :disabledButtons="true"
                  :loadedAction="item.defaultParams.open.loadedAction"
                  :type="item ? item.type : ''"
                  :files="getFiles"
                  label-position="top"
                  @setFormLoading="value => (formLoading = value)"
                >
                </MetadataForm>
              </div>
            </div>
            <MetadataForm
              v-else
              :ref="`form-${item.id}`"
              :defParams="item.defaultParams.open"
              :disabledButtons="true"
              :loadedAction="item.defaultParams.open.loadedAction"
              :type="item ? item.type : ''"
              :files="uploadedFiles || getFiles"
              label-position="top"
              @set-template-files="setTemplateFiles"
              @need-coordination="val => (needCoordination = val)"
              @setFormLoading="value => (formLoading = value)"
            >
            </MetadataForm>
          </div>
          <!-- v-if="item.id === getCurrentStep.id" -->
        </div>
      </div>
    </div>
    <div slot="footer">
      <div class="footer">
        <Button
          v-loading="formLoading"
          :key="getStepKey"
          buttonSize="big"
          buttonColor="darkBlue"
          :buttonText="saveButtonName"
          class="footer__button-ok"
          :disabled="disableButton || formLoading"
          @click.once="submit"
        />
        <Button
          buttonSize="big"
          buttonColor="blue"
          buttonText="Отмена"
          @click="closeDialog"
          class="footer__button-cancel"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { eventBus } from '@/bus';
import { store } from '@/store';
import { Dialog } from 'element-ui';
import Button from 'Elements/Button/Button';
import MetadataForm from './MetadataForm';
import GeneralMenuItem from 'Elements/Dialog/Details/GeneralMenuItem';
import { mixin, parseIntent, errorMsg } from '@/utils/mixins';
import { scrollToError } from '@/utils/helpers';
import { postController, getController } from '@/controllers/request.js';
import { INTENT_AREA, EVENTBUS_EVENTS } from '@/utils/constants';

export default {
  mixins: [errorMsg, mixin, parseIntent],
  props: {
    is_visible: {
      type: Boolean
    },
    selectedStage: {
      type: Object
    },
    data: {
      type: Object
    },
    title: {
      type: String,
      default: 'Перевод на этап'
    },
    subtitle: {
      type: String
    },
    defaultValue: {
      type: String,
      default: '0'
    },
    max: {
      type: String
    }
  },
  data() {
    return {
      removedTemplateFiles: [], // пушить шаблонные файлы при удалении
      uploadedFiles: [],
      needCoordination: '',
      formLoading: true
    };
  },
  created() {
    eventBus.$on(EVENTBUS_EVENTS.SET_FORM_LOADING, val => {
      this.formLoading = val;
    });
  },
  beforeDestroy() {
    eventBus.$off(EVENTBUS_EVENTS.SET_FORM_LOADING);
  },
  mounted() {
    if (this.intents?.length) {
      for (let i = 0; i < this.intents.length; i++) {
        if (
          this.intents[i].intentArea == INTENT_AREA.POPUP &&
          this.intents[i].intentType == INTENT_AREA.GROUP_POPUP
        ) {
          this.getDialogData(this.intents[i]);
        }
      }
    }
  },
  computed: {
    currentStep() {
      return this.getSteps.find(item => item.id === this.getCurrentStep.id)?.id;
    },
    getStepKey() {
      return store.state.common.generalStepsDialog.stepKey;
    },
    intents() {
      return store.state.common.visible_dialog['general_dialog'].intents;
    },
    getLoading() {
      return store.state.dialog.loading || false;
    },
    getFiles() {
      return store.state.common.generalStepsDialog.files;
    },
    disableButton() {
      const disabled = this.getSteps.map(item => {
        if (item.warning && item.required) {
          return true;
        } else {
          return false;
        }
      });
      return disabled.includes(true);
    },
    getGeneralScheme() {
      return store.state.common.generalStepsDialog.schema;
    },
    getStageName() {
      const stageName =
        store.state.candidate.selectedStage?.fields[0]?.schema?.stage_name
          ?.text;
      if (stageName) {
        return `${this.title} ${stageName.toLowerCase()}`;
      } else {
        return this.getCurrentStep.name;
      }
    },
    getSteps() {
      return store.state.common.generalStepsDialog.steps;
    },
    getCurrentStep() {
      return store.state.common.generalStepsDialog.currentStep;
    },
    saveButtonName() {
      if (this.needCoordination == '1') {
        return 'Далее к согласованию';
      } else {
        return this.getCurrentStep?.label_button_save || 'Перевести';
      }
    }
  },
  methods: {
    setTemplateFiles(files = []) {
      this.removedTemplateFiles = this.removedTemplateFiles
        .slice()
        .filter(file => file.type == 'forward');
      this.uploadedFiles = [
        ...this.getFiles.filter(file => !file.type || file.type == 'forward'),
        ...files.map(f => ({
          ...f,
          type: 'template',
          uid: f.id,
          size: f.filesize || 0
        }))
      ];
      store.commit('common/setGeneralEmailsFiles', this.uploadedFiles);
    },
    closeDialog() {
      this.$emit('cancel-callback');
      store.commit('common/setRemoveGeneralDialog');
      store.commit('candidate/setSelectedStage', null);
    },
    async getDialogData(intents) {
      const options = new FormData();
      let url = intents.request.url;

      for (let key in intents.request.request_params) {
        options.append(key, intents.request.request_params[key]);
      }

      try {
        const response = await postController({ url, options });
        if (response?.data?.tabs) {
          store.commit('common/setGeneralSteps', response.data.tabs);
        }
      } catch (err) {
        this.catchError(err, 'Возникла ошибка получения данных');
      }
    },
    getErrorValidFields(form) {
      form.validate();
      return form.fields
        .filter(field => field.isRequired && field.validateState == 'error')
        .map(field => field?.labelFor);
    },
    async submit() {
      this.formLoading = true;
      const validForms = [];

      for (let index = 0; index < this.getSteps.length; index++) {
        const step = this.getSteps[index];
        validForms.push(await this.onceStepValidate(step));
      }
      if (validForms.includes(false)) {
        this.formLoading = false;
        if (this.getCurrentStep.error && this.getCurrentStep.required) return;
        this.changeStep(
          this.getSteps.find(item => item.required && item.error)
        );
        const errorField = this.getErrorValidFields(
          this.$refs['form-' + this.getCurrentStep.id][0].$children[0]
        );
        this.$nextTick(() => {
          scrollToError(
            errorField,
            document.getElementsByClassName('dialog__content__right')[0]
          );
        });
      } else {
        for (let index = 0; index < this.getSteps.length; index++) {
          const item = this.getSteps[index];

          if (item.id === 'HRPAC_EVENT' && item.required) {
            let context =
              this.$refs['form-HRPAC_EVENT'][0]?.children[0].children[0].__vue__
                .$children[0];

            //исправление дат начала и конца события для формы отправки письма
            context.form.date_start = `${context.form.date_event} ${context.form.date_start}`;
            context.form.date_end = `${context.form.date_event} ${context.form.date_end}`;

            store.commit('common/setDialogValue', {
              name: 'form',
              value: context.form,
              id: item.id
            });

            if (+context.form.email_switcher) {
              context =
                this.$refs['form-HRPAC_EVENT'][0]?.children[0].children[0]
                  .__vue__.$refs['email_form'];

              let eventFilesForm = {};

              if (context.$children[0].files?.length) {
                let newFiles = [...context.$children[0].files];

                newFiles.forEach(file => {
                  if (file.type == 'template' || file.type == 'forward') {
                    eventFilesForm['template_attachment'] = eventFilesForm[
                      'template_attachment'
                    ]
                      ? [...eventFilesForm.template_attachment, file.id]
                      : [file.id];
                  } else if (file.type == 'removed') {
                    eventFilesForm['temp_remove_attachment'] =
                      eventFilesForm.temp_remove_attachment
                        ? [...eventFilesForm.temp_remove_attachment, file.id]
                        : [file.id];
                  } else {
                    eventFilesForm['email_attachment'] =
                      eventFilesForm.email_attachment
                        ? [...eventFilesForm.email_attachment, file.raw]
                        : [file.raw];
                  }
                });
              }

              try {
                const options = new FormData();

                for (let key in context.defaultParams) {
                  options.append(key, context.defaultParams[key]);
                }

                for (let key in context.$children[0].form) {
                  options.append(key, context.$children[0].form[key]);
                }

                if (eventFilesForm && Object.keys(eventFilesForm).length) {
                  for (let param of Object.keys(eventFilesForm)) {
                    if (Array.isArray(eventFilesForm[param])) {
                      eventFilesForm[param].forEach(element => {
                        options.append(`${param}[]`, element);
                      });
                    } else {
                      options.set(param, eventFilesForm[param]);
                    }
                  }
                }
                postController({ options });
              } catch (error) {
                console.error(error);
              }
            }
            this.showNotification({
              title: 'Встреча запланирована',
              message: 'Ответы от участников будут направлены на вашу почту',
              type: 'success',
              position: 'center'
            });
          } else {
            const context = this.$refs['form-' + item.id][0];
            store.commit('common/setDialogValue', {
              name: 'form',
              value: context.form,
              id: item.id
            });
          }
        }

        store.commit('dialog/setLoading', true);

        const status = await store.dispatch('common/saveGeneralForm');

        if (status && !this.getCurrentStep?.single_popup) {
          this.$emit('change-stage');
          if (status.intents?.length) {
            store.commit('event/setRemoveIntentsAll');
            store.commit('event/setIntents', status.intents);
            // this.parse();
          }
        } else {
          this.$emit('cancel-callback');
          store.commit('common/setRemoveGeneralDialog');
        }
      }
    },
    async onceStepValidate(step) {
      if (step.id === 'HRPAC_EVENT' && step.required) {
        const context =
          this.$refs['form-HRPAC_EVENT'][0]?.children[0].children[0].__vue__
            ?.$children[0];

        let validStep;
        try {
          await context.$children[0].validate(valid => {
            store.commit('common/setDialogValue', {
              name: 'error',
              value: !valid,
              id: step.id
            });

            if (!step.required) {
              validStep = true;
            } else {
              validStep = valid;
              if (validStep && +context.form.email_switcher) {
                const emailContext =
                  this.$refs['form-HRPAC_EVENT'][0]?.children[0].children[0]
                    .__vue__.$refs['email_form'];

                emailContext.$children[0].$children[0].validate(valid => {
                  store.commit('common/setDialogValue', {
                    name: 'error',
                    value: !valid,
                    id: step.id
                  });

                  if (!step.required) {
                    validStep = true;
                  } else {
                    validStep = valid;
                  }
                });
              }
            }
          });
          return validStep;
        } catch (error) {
          console.error(error);
        }
      } else {
        const context = this.$refs['form-' + step.id][0];
        let validStep;
        try {
          await context.$children[0].validate(valid => {
            store.commit('common/setDialogValue', {
              name: 'error',
              value: !valid,
              id: step.id
            });
            if (!step.required) {
              validStep = true;
            } else {
              validStep = valid;
            }
          });
          return validStep;
        } catch (error) {
          console.error(error);
        }
      }
    },
    changeStep(step) {
      //Обработчик повторного нажатия на этап
      if (this.getCurrentStep.id === step.id) return;
      //Валидируем вкладку, если ошибка, окрашиваем.
      this.onceStepValidate(this.getCurrentStep);
      //Перевод на следующий шаг
      store.commit('common/setNewCurrentStep', step);
    },
    changeRequired(value, id) {
      store.commit('common/setDialogValue', { name: 'required', value, id });
    },
    async changeCandidateStep() {
      if (this.intents?.length) {
        for (let i = 0; i < this.intents.length; i++) {
          if (this.intents[i].intentArea == INTENT_AREA.AJAX) {
            let url = this.intents[i].request.url;

            for (let key in this.intents[i].request?.request_params) {
              url += `&${key}=${this.intents[i].request.request_params[key]}`;
            }

            try {
              await getController({
                url
              });
              store.commit('common/setVisibleDialog', {
                name: 'general_dialog',
                val: false
              });
              store.commit('dialog/setLoading', false);
            } catch (err) {
              this.catchError(err, 'Возникла ошибка');
            }
          }
        }
      } else {
        store.commit('common/setVisibleDialog', {
          name: 'general_dialog',
          val: false
        });
        store.commit('dialog/setLoading', false);
      }
    }
  },
  components: {
    'el-dialog': Dialog,
    Button,
    GeneralMenuItem,
    MetadataForm
  },
  destroyed() {
    store.commit('rightPanel/setParam', {
      name: 'vacancyId',
      val: ''
    });
  }
};
</script>
<style lang="scss" scoped>
.dialog {
  & ::v-deep .el-dialog {
    padding: 0;

    &__header {
      padding: 20px 24px !important;
      border-bottom: 1px solid $black-20;
    }

    &__footer {
      padding: 20px 24px !important;
      margin-top: 0;
      border-top: 1px solid $black-20;

      .footer {
        box-sizing: border-box;
      }
    }
  }
}

.dialog__content {
  display: flex;
  height: 600px;
  text-align: left;

  .open {
    display: block;
  }

  .hide {
    display: none;
  }

  &__left {
    background-color: $black-20;
    border-right: 1px solid $black-20;
    width: 293px;
    min-height: 600px;
    overflow: auto;
  }

  &__right {
    width: 794px;
    height: 600px;
    overflow: auto;
    padding: 24px 16px 16px 16px;
  }
}
</style>
